(function () {
  const THRESHOLD = 8;
  const DRAG_THRESHOLD = 6;

  function getScrollEl(indicatorEl) {
    if (!indicatorEl) return null;

    if (indicatorEl.classList.contains('drawer__menu')) {
      return indicatorEl;
    }

    return indicatorEl.querySelector(':scope > .sliderow__links, :scope > [data-links]') ||
      indicatorEl.querySelector('[data-links]');
  }

  function updateScrollHint(scrollEl, indicatorEl) {
    if (!scrollEl || !indicatorEl) return;

    const scrollable = scrollEl.scrollHeight - scrollEl.clientHeight > THRESHOLD;
    const atBottom = scrollEl.scrollTop + scrollEl.clientHeight >= scrollEl.scrollHeight - THRESHOLD;

    indicatorEl.classList.toggle('has-overflow', scrollable);
    indicatorEl.classList.toggle('is-scrolled-bottom', atBottom);
  }

  function scrollByPage(scrollEl) {
    if (!scrollEl) return;

    const amount = Math.max(120, Math.round(scrollEl.clientHeight * 0.75));
    const maxScroll = scrollEl.scrollHeight - scrollEl.clientHeight;
    const nextTop = Math.min(scrollEl.scrollTop + amount, maxScroll);

    if (typeof scrollEl.scrollTo === 'function') {
      scrollEl.scrollTo({top: nextTop, behavior: 'smooth'});
    } else {
      scrollEl.scrollTop = nextTop;
    }
  }

  function enableDragScroll(scrollEl) {
    if (!scrollEl || scrollEl.dataset.dragScrollBound === 'true') return;

    scrollEl.dataset.dragScrollBound = 'true';

    let pointerId = null;
    let startY = 0;
    let startScrollTop = 0;
    let dragging = false;
    let moved = false;
    let activePointerType = null;

    const onPointerDown = (event) => {
      if (event.target.closest('[data-scroll-hint-button], .sliderule__scroll-hint__icon')) return;
      if (event.pointerType === 'touch') return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (scrollEl.scrollHeight - scrollEl.clientHeight <= THRESHOLD) return;

      pointerId = event.pointerId;
      activePointerType = event.pointerType;
      startY = event.clientY;
      startScrollTop = scrollEl.scrollTop;
      dragging = true;
      moved = false;

      scrollEl.classList.add('is-dragging');

      try {
        scrollEl.setPointerCapture(pointerId);
      } catch (error) {
        // Older browsers may not support pointer capture.
      }
    };

    const onPointerMove = (event) => {
      if (!dragging || event.pointerId !== pointerId) return;

      const deltaY = event.clientY - startY;

      if (!moved && Math.abs(deltaY) < DRAG_THRESHOLD) return;

      moved = true;
      event.preventDefault();
      scrollEl.scrollTop = startScrollTop - deltaY;
    };

    const endDrag = (event) => {
      if (!dragging || (event && event.pointerId !== pointerId)) return;

      dragging = false;
      scrollEl.classList.remove('is-dragging');

      if (pointerId !== null) {
        try {
          scrollEl.releasePointerCapture(pointerId);
        } catch (error) {
          // Ignore release errors when capture was never set.
        }
      }

      pointerId = null;
      activePointerType = null;
    };

    const onClickCapture = (event) => {
      if (!moved || activePointerType === 'touch') return;
      if (event.target.closest('[data-scroll-hint-button], .sliderule__scroll-hint__icon')) return;
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    };

    let touchStartY = 0;
    let touchStartScrollTop = 0;
    let touchDragging = false;
    let touchMoved = false;

    const onTouchStart = (event) => {
      if (window.PointerEvent) return;
      if (event.target.closest('[data-scroll-hint-button], .sliderule__scroll-hint__icon')) return;
      if (event.touches.length !== 1) return;
      if (scrollEl.scrollHeight - scrollEl.clientHeight <= THRESHOLD) return;

      touchStartY = event.touches[0].clientY;
      touchStartScrollTop = scrollEl.scrollTop;
      touchDragging = true;
      touchMoved = false;
      scrollEl.classList.add('is-dragging');
    };

    const onTouchMove = (event) => {
      if (!touchDragging || event.touches.length !== 1) return;

      const deltaY = event.touches[0].clientY - touchStartY;

      if (!touchMoved && Math.abs(deltaY) < DRAG_THRESHOLD) return;

      touchMoved = true;
      event.preventDefault();
      scrollEl.scrollTop = touchStartScrollTop - deltaY;
    };

    const onTouchEnd = () => {
      if (!touchDragging) return;
      touchDragging = false;
      scrollEl.classList.remove('is-dragging');
    };

    scrollEl.addEventListener('pointerdown', onPointerDown, {passive: true});
    scrollEl.addEventListener('pointermove', onPointerMove, {passive: false});
    scrollEl.addEventListener('pointerup', endDrag, {passive: true});
    scrollEl.addEventListener('pointercancel', endDrag, {passive: true});
    scrollEl.addEventListener('pointerleave', endDrag, {passive: true});
    scrollEl.addEventListener('click', onClickCapture, true);

    scrollEl.addEventListener('touchstart', onTouchStart, {passive: true});
    scrollEl.addEventListener('touchmove', onTouchMove, {passive: false});
    scrollEl.addEventListener('touchend', onTouchEnd, {passive: true});
    scrollEl.addEventListener('touchcancel', onTouchEnd, {passive: true});
  }

  function bindScrollHint(indicatorEl) {
    if (indicatorEl.dataset.scrollHintBound === 'true') return;

    const scrollEl = getScrollEl(indicatorEl);

    if (!scrollEl) return;

    indicatorEl.dataset.scrollHintBound = 'true';

    if (!scrollEl.hasAttribute('data-scroll-lock-scrollable')) {
      scrollEl.setAttribute('data-scroll-lock-scrollable', '');
    }

    enableDragScroll(scrollEl);

    const onChange = () => updateScrollHint(scrollEl, indicatorEl);

    scrollEl.addEventListener('scroll', onChange, {passive: true});
    new ResizeObserver(onChange).observe(scrollEl);
    new ResizeObserver(onChange).observe(indicatorEl);
    onChange();
  }

  function refreshScrollHints(root = document) {
    root.querySelectorAll('.sliderule__panel, .drawer__menu[data-sliderule-pane="0"]').forEach(bindScrollHint);
  }

  function refreshOpenPanel(trigger) {
    const key = trigger.getAttribute('data-sliderule-open');
    const panel = document.getElementById(key)?.querySelector('.sliderule__panel');

    if (!panel) return;

    bindScrollHint(panel);

    const scrollEl = getScrollEl(panel);
    const onChange = () => updateScrollHint(scrollEl, panel);

    requestAnimationFrame(onChange);
    setTimeout(onChange, 100);
    setTimeout(onChange, 500);
    setTimeout(onChange, 900);
  }

  let lastHintActivateAt = 0;

  function handleHintActivate(event) {
    const button = event.target.closest('[data-scroll-hint-button], .sliderule__scroll-hint__icon');

    if (!button) return;

    const now = Date.now();
    if (now - lastHintActivateAt < 400) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    const hint = button.closest('.sliderule__scroll-hint');
    const indicatorEl = hint && hint.parentElement;

    if (!indicatorEl) return;

    // Ignore top-level hint while a submenu pane is open.
    if (
      indicatorEl.matches('.drawer__menu[data-sliderule-pane]') &&
      indicatorEl.getAttribute('data-sliderule-pane') !== '0'
    ) {
      return;
    }

    const scrollEl = getScrollEl(indicatorEl);

    if (!scrollEl) return;

    lastHintActivateAt = now;
    event.preventDefault();
    event.stopPropagation();
    scrollByPage(scrollEl);
    updateScrollHint(scrollEl, indicatorEl);
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-sliderule-open]');
    if (trigger) refreshOpenPanel(trigger);

    handleHintActivate(event);
  });

  // Capture touch taps that may not fire click reliably over scrolling layers.
  document.addEventListener(
    'touchend',
    (event) => {
      if (!event.target.closest('[data-scroll-hint-button], .sliderule__scroll-hint__icon')) return;
      handleHintActivate(event);
    },
    {passive: false}
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => refreshScrollHints());
  } else {
    refreshScrollHints();
  }

  document.addEventListener('shopify:section:load', (event) => {
    refreshScrollHints(event.target);
  });
})();
